<template>
	<div v-if="!rowEmpty && deliveryReportsProp">
    <div v-if="!isLoading">
      <div class="row">
        <div class="col-3 b-r">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalSending}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesSending}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('sendingLabel','sendingLabel') }}</div>
          </div>
        </div>
        <div class="col-3 b-r">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalEmailed}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesEmailed}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('emailedLabel','emailedLabel') }}</div>
          </div>
        </div>
        <div class="col-3">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalFaxed}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesFaxed}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('faxedLabel','faxedLabel') }}</div>
          </div>
        </div>
        <div class="col-3 b-l">
          <div class="el-tablo centered padded value-box">
            <!--<div class="icon-div">
              <fontAwesomeIcon :icon="['fa', 'file-alt']" class="bg-icon"/>
            </div>-->
            <div class="value text-primary">{{deliveryReportsProp.docNum}}</div>
            <div class="label">{{ t('docsLabel','docsLabel') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 b-r b-t">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPosted}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesPosted}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('postedLabel','postedLabel') }}</div>
          </div>
        </div>
        <div class="col-3 b-r b-t">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalOnline}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesOnline}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('onlineLabel','onlineLabel') }}</div>
          </div>
        </div>
        <div class="col-3 b-t">
          <div class="el-tablo centered padded">
            <div class="row">
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalTransfered}}d</div>
              </div>
              <div class="col-sm-12 col-md-6 mobile-font">
                <div class="value">{{deliveryReportsProp.totalPagesTransfered}}p</div>
              </div>
            </div>
            <div class="label text-center">{{ t('dataTransferLabel','dataTransferLabel') }}</div>
          </div>
        </div>
        <div class="col-3 b-l b-t">
          <div class="el-tablo centered padded value-box">
            <!--<div class="icon-div">
              <fontAwesomeIcon :icon="['fa', 'file']" class="bg-icon"/>
            </div>-->
            <div class="value text-primary">{{deliveryReportsProp.docPages}}</div>
            <div class="label">{{ t('pagesLabel','pagesLabel') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <vcl-table :columns="4" :rows="2"></vcl-table>
    </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VclTable } from 'vue-content-loading'

export default {
	props: ['deliveryReportsRow', 'deliveryReportsProp', 'isBusy'],
	  name: 'Calculations',
	data() {
    return {
			rowEmpty: false
		}
	},
	created() {
		if(this.$props.deliveryReportsRow) {
      this.rowEmpty = this.$props.deliveryReportsRow
		}
	},
	components: {
    VclTable
	},
	methods: {
	},
	computed: {
    isLoading() {
      if(this.$props.isBusy) {
        return this.$props.isBusy
      }
    }
	}
}
</script>

<style scoped>
  @media (max-width: 767px) {
    .mobile-font > div {
      font-size: 22px;
    }
  }
</style>